import React from 'react';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import useMediaQuery from '../../lib/custom-hooks/useMediaQuery';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import MobileSeriesDetails from './components/mobileSeriesDetails';
import DesktopSeriesDetails from './components/desktopSeriesDetails';
import { TContentHubSeriesDetailsProps } from './types/productSeriesDetailFeature.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const ProductSeriesDetailFeature = (props: TContentHubSeriesDetailsProps): JSX.Element | null => {
  const apiResponse =
    isEmptyResponse(props) && props?.fields?.apiData?.innerComponents && props?.fields?.apiData?.innerComponents?.length > 0;
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent rendering={props?.rendering} title={props?.fields?.apiData?.title} template="Features">
      {isDesktop ? <DesktopSeriesDetails {...props} /> : <MobileSeriesDetails {...props} />}
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(ProductSeriesDetailFeature);
